import React, { useEffect, useRef, useState } from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { questionnaireResumeActions } from '../../core/questionnaire-resume/actions';
import { QuestionnaireDetails } from './home/questionnaires/QuestionnaireDetails';
import { QuestionnairesList } from './home/questionnaires/QuestionnairesList';
import LoadingIndicator from '../components/loading-indicator/loading-indicator';

const animationClass = {
    appearActive: 'animate__animated animate__slideInRight',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft',
}

const QuestionnairesPage = (params) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const questionnairesListRef = useRef()
    const questionnairesRef = useRef()
    const showAnimation = true;
    const questionnaire_resume = useSelector(state => state.questionnaire_resume);
    const [currentSection, setCurrentSection] = useState('questionnaires_list');
    const [currentQuestionnaireId, setCurrentQuestionnaireId] = useState();
    const currentQuestionnaire = useSelector(state => state.questionnaire_list);

    useEffect(() => {
        dispatch(questionnaireResumeActions.loadQuestionnaireResume());
    }, [dispatch]);

    const handleNextSection = (section, event, id = null) => {
        event.preventDefault();
        if (section === 'questionnaire') {
            const currentItem = questionnaire_resume.data.find(questionnaire => questionnaire.id == id);

            if (currentItem) {
                if (!currentItem.submitted) {
                    navigate(`/questionnaire/${id}`);
                } else {
                    setCurrentSection(section)
                    setCurrentQuestionnaireId(id)
                }
            }
        } else {
            setCurrentSection(section)
            setCurrentQuestionnaireId(null)
        }
    }

    return (
        <>
            <div className="container-fluid h-100">
                <div className='view overflow-hidden questionnaires-content h-100 position-relative'>
                    <TransitionGroup component={null}>
                        {currentSection === "questionnaires_list" && (
                            <CSSTransition nodeRef={questionnairesListRef} key={"questionnaires_list"} classNames={showAnimation ? animationClass : ''} timeout={{ enter: 1000, exit: 1000 }} appear>
                                <div ref={questionnairesListRef}>
                                    <QuestionnairesList
                                        questionnairesResumenList={questionnaire_resume.data}
                                        handleNextSection={handleNextSection}
                                    />
                                </div>
                            </CSSTransition>
                        )}                

                        {currentSection === "questionnaire" && (
                            <CSSTransition nodeRef={questionnairesRef} key={"questionnaire"} classNames={showAnimation ? animationClass : ''} timeout={{ enter: 1000, exit: 1000 }} appear>
                                <div ref={questionnairesRef}>
                                    <QuestionnaireDetails
                                        questionnaireId={currentQuestionnaireId}
                                        handleNextSection={handleNextSection}
                                    />
                                </div>
                            </CSSTransition>
                        )}
                    </TransitionGroup>
                </div>
            </div>

            {(questionnaire_resume.isPending || currentQuestionnaire?.isPending) && <LoadingIndicator />}
        </>
    )
}
export default QuestionnairesPage